export default "__VITE_ASSET__BVpk0qga__"